// extracted by mini-css-extract-plugin
export default {"header":"Fixed_header__ws0G0","footer":"Fixed_footer__lokVU"};